/*!
 * GBM Market Chip — "ZIP | Method" header controller
 * - Reads localStorage.gbm_zip for ZIP
 * - Derives method from domain (goodbatchmama.com => Drive-Up Delivery, gbmships.com => Shipping)
 * - Opens existing ZIP modal via custom event; robust fallback to shipping site with ?gate=1
 * - Safe, namespaced, a11y-friendly dropdown
 */

(function () {
  var ROOT_ID = 'gbm-market-chip';
  var root = document.getElementById(ROOT_ID);
  if (!root) return; // no-op if markup isn't present

  // Elements
  var btn   = document.getElementById('gbm-market-btn');
  var menu  = document.getElementById('gbm-market-menu');
  var label = document.getElementById('gbm-market-label');

  // Config via data-* (with sensible defaults)
  var openZipEvt  = root.dataset.openZipEvent || 'gbm:openZipChecker';
  var localUrlStr = root.dataset.localUrl || 'https://www.goodbatchmama.com/';
  var shipUrlStr  = root.dataset.shipUrl  || 'https://gbmships.com/';
  // Optional flags
  var preserveCrossSite = (root.dataset.preserveCrossSite || 'false').toLowerCase() === 'true';

  // Domain → method text
  var host = location.hostname;
  var onLocal = /\bgoodbatchmama\.com$/i.test(host);
  var onShip  = /\bgbmships\.com$/i.test(host);
  var methodTxt = onLocal ? 'Drive-Up Delivery' : (onShip ? 'Shipping' : 'Choose');

  // Helpers
  function gbmSetCookie(name, value, days) {
  try {
    var maxAge = days ? days*24*60*60 : 0; // seconds
    var parts = [
      name + '=' + encodeURIComponent(value),
      'Path=/',
      'SameSite=Lax'
    ];
    if (maxAge) parts.push('Max-Age=' + maxAge);
    if (location.protocol === 'https:') parts.push('Secure');
    document.cookie = parts.join('; ');
  } catch(e) {}
}
function gbmGetCookie(name) {
  try {
    return document.cookie.split('; ').reduce((acc, c) => {
      const [k, ...v] = c.split('=');
      return k === name ? decodeURIComponent(v.join('=')) : acc;
    }, '');
  } catch(e) { return ''; }
}
function gbmDelCookie(name) {
  try {
    document.cookie = name + '=; Path=/; Max-Age=0; SameSite=Lax';
  } catch(e) {}
}

(function syncZipFromCookie(){
  try {
    if (!localStorage.getItem('gbm_zip')) {
      var cz = gbmGetCookie('gbm_zip'); // helper from section A
      if (cz) localStorage.setItem('gbm_zip', cz);
    }
  } catch(e) {}
})();


  function getZip() {
    try { return localStorage.getItem('gbm_zip') || ''; }
    catch (e) { return ''; }
  }
  function setZip(z) {
    try { localStorage.setItem('gbm_zip', (z || '').trim()); }
    catch (e) {}
  }

  // Shipping site is authoritative "ship"
function siteMode() { return 'ship'; }

// Persist/read the gate's recommendation: 'local' | 'ship'
function getStoredMarket(){
  var c = gbmGetCookie('gbm_market');
  if (c) return c;
  try { return localStorage.getItem('gbm_market') || ''; } catch(_) { return ''; }
}
function setStoredMarket(mode){
  if (mode !== 'local' && mode !== 'ship') return;
  try { localStorage.setItem('gbm_market', mode); } catch(_){}
  gbmSetCookie('gbm_market', mode, 90);
}

// Text for the summary line
function bestForText(mode){
  return (mode === 'local') ? 'Best for: Drive-Up Delivery' : 'Best for: Shipping';
}

function renderShipMenuSummary() {
  var box = document.getElementById('gbm-market-dd-summary');
  if (!box) return;

  var zip = getZip();
  var rec = getStoredMarket() || siteMode(); // prefer stored recommendation if present

  if (zip && /^\d{5}$/.test(zip)) {
    box.innerHTML =
      '<div class="gbm-chip__zip"style="color:#b36a5e"><strong>' + zip + '</strong></div>' +
      '<div class="gbm-chip__bestfor"style="color:#808080">' + bestForText(rec) + '</div>';
  } else {
    box.innerHTML = '<div class="gbm-chip__bestfor">Enter your ZIP to see options</div>';
  }
}

function setAttentionState(recMode){
  var rootEl = document.getElementById('gbm-market-chip');
  if (!rootEl) return;
  var needsSwitch = !!recMode && recMode !== siteMode();
  rootEl.classList.toggle('gbm--attention', needsSwitch);
}

function updateLabel() {
  var zip = getZip();
  label.textContent = (zip ? zip : 'ZIP?') + ' | ' + methodTxt;

  // New: render dropdown summary + attention state
  renderShipMenuSummary();
  setAttentionState(getStoredMarket() || siteMode());
}

function preserveQueryAndHash(u) {
  try {
    const dest = new URL(u, window.location.origin);
    const cur  = new URL(window.location.href);

    // Merge queries: keep dest’s values (e.g., gbm_zip) if keys collide
    cur.searchParams.forEach((v, k) => {
      if (!dest.searchParams.has(k)) dest.searchParams.append(k, v);
    });

    // Only copy hash if dest doesn't already define one
    if (!dest.hash && cur.hash) dest.hash = cur.hash;

    return dest.toString();
  } catch (e) {
    return u;
  }
}

function gotoUrl(u, opts) {
  let urlStr = u;
  if (opts && opts.preserveQH) urlStr = preserveQueryAndHash(u);
  // Re-assert gbm_zip in case other code calls gotoUrl directly
  urlStr = appendZipParam(urlStr);
  window.location.href = urlStr;
}

  function appendZipParam(u, mode) {
  try {
    var z = getZip && getZip() || '';
    var url = new URL(u, window.location.origin);
    if (/^\d{5}$/.test(z)) url.searchParams.set('gbm_zip', z);
    if (mode) url.searchParams.set('gbm_mode', mode);
    return url.toString();
  } catch (e) {
    return u;
  }
}

  // Robust gate prompt fallback that never creates malformed paths
  function forceGatePrompt() {
    try {
      if (onShip) {
        // Stay on current host; just ensure ?gate=1 is present
        var stay = new URL(window.location.href);
        stay.searchParams.set('gate', '1');
        var __z = getZip() || '';
        if (/^\d{5}$/.test(__z)) stay.searchParams.set('gbm_zip', __z);
        window.location.href = stay.toString();
      } else {
        // Jump to shipping base URL with ?gate=1
        var ship = new URL(shipUrlStr);
        ship.searchParams.set('gate', '1');
        var __z2 = getZip() || '';
        if (/^\d{5}$/.test(__z2)) ship.searchParams.set('gbm_zip', __z2);
        window.location.href = ship.toString();
      }
    } catch (e) {
      // Absolute worst-case fallback
      window.location.href = onShip ? (window.location.pathname + '?gate=1') : (shipUrlStr + '?gate=1');
    }
  }

  // Ensure we have a ZIP before continuing; if not, open modal (or fallback)
function ensureZipThen(next) {
   var zip = getZip();
   if (zip) { if (typeof next === 'function') next(); return; }

   // Ask existing ZIP checker to open
   try {
     window.dispatchEvent(new CustomEvent(openZipEvt, { detail: { source: 'header-chip' } }));
   } catch (e) {}

   // If the ZIP modal handles it, continue automatically afterward
   var ran = false;
   function runNextOnce() {
     if (ran) return;
     ran = true;
     if (typeof next === 'function') next();
     window.removeEventListener('gbm:zipSelectionConfirmed', onConfirm, true);
   }
   function onConfirm(e) {
     // A valid ZIP was picked; proceed
     if (e && e.detail && /^\d{5}$/.test(e.detail.zip || '')) {
       // ensure storage is populated before nav (belt & suspenders)
       try { localStorage.setItem('gbm_zip', e.detail.zip); } catch(_){}
       try { document.cookie = 'gbm_zip=' + encodeURIComponent(e.detail.zip) + '; Path=/; Max-Age=' + (60*60*24*90) + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch(_){}
       runNextOnce();
     }
   }
   window.addEventListener('gbm:zipSelectionConfirmed', onConfirm, true);

   // Robust fallback if nothing handled it at all
   setTimeout(function () {
     if (!window.__gbmZipHandled) {
       // Open hard fallback (stays on same host or hops to ship) and include any known ZIP
       forceGatePrompt();
     }
   }, 300);
 }

  // Menu controls (a11y)
// Cache items once (they’re static)
function getMenuItems() {
  return Array.prototype.slice.call(menu.querySelectorAll('.gbm-area__item'));
}

function openMenu() {
  // make it perceivable & focusable before moving focus
  menu.style.display = 'block';
  menu.setAttribute('aria-hidden', 'false');
  if ('inert' in menu) menu.inert = false;

  btn.setAttribute('aria-expanded', 'true');

  document.addEventListener('click', onDocClick, true);
  document.addEventListener('keydown', onEsc, true);

  // move focus to first item for keyboard users
  var items = getMenuItems();
  if (items.length) items[0].focus();
  renderShipMenuSummary();
}

function closeMenu() {
  // return focus to the button BEFORE hiding from a11y
  if (document.activeElement && menu.contains(document.activeElement)) {
    btn.focus();
  }

  btn.setAttribute('aria-expanded', 'false');

  // now it’s safe to hide from a11y and visuals
  menu.setAttribute('aria-hidden', 'true');
  if ('inert' in menu) menu.inert = true;
  menu.style.display = 'none';

  document.removeEventListener('click', onDocClick, true);
  document.removeEventListener('keydown', onEsc, true);
}
  function onDocClick(e) { if (!root.contains(e.target)) closeMenu(); }
  function onEsc(e) { if (e.key === 'Escape') closeMenu(); }

  // Button toggles menu (no auto-nudge to prompt ZIP on first click)
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var isOpen = menu.getAttribute('aria-hidden') === 'false';
    isOpen ? closeMenu() : openMenu();
  });

  // Menu actions
  menu.addEventListener('click', function (e) {
    var item = e.target.closest('.gbm-area__item');
    if (!item) return;

    // Change ZIP… -> force the prompt even if a ZIP exists
    if (item.id === 'gbm-change-zip') {
      closeMenu();
      try {
        window.dispatchEvent(new CustomEvent(openZipEvt, { detail: { force: true, source: 'header-chip' } }));
      } catch (err) {}
      setTimeout(function () {
        if (!window.__gbmZipHandled) forceGatePrompt();
      }, 150);
      return;
    }

    // Switch to a method (site); method is domain-derived
    var target = item.dataset.target; // 'local' | 'ship'
    closeMenu();

    if (target === 'local' && !onLocal) {
      ensureZipThen(function () {
        gotoUrl(appendZipParam(localUrlStr, 'local'), { preserveQH: preserveCrossSite });
      });
      return;
    }
    if (target === 'ship' && !onShip) {
      ensureZipThen(function () {
        gotoUrl(appendZipParam(shipUrlStr, 'ship'), { preserveQH: preserveCrossSite });
      });
      return;
    }
    // If already on the target site, no nav needed
  });

  // Listen for modal confirmation to update ZIP instantly
  // Expecting: window.dispatchEvent(new CustomEvent('gbm:zipSelectionConfirmed', { detail:{ zip:'37932', mode:'local' }}));
window.addEventListener('gbm:zipSelectionConfirmed', function (e) {
  if (e && e.detail && e.detail.zip) setZip((e.detail.zip || '').trim());
  // gate may send e.detail.mode = 'local' | 'ship'
  var m = e && e.detail && e.detail.mode;
  if (m === 'local' || m === 'ship') setStoredMarket(m);

  window.__gbmZipHandled = true;
  updateLabel();
}, true);

  // Paint initial state and show chip
  updateLabel();
  root.style.display = 'inline-block';

  window.addEventListener('pageshow', updateLabel);
  if (window.__gbmZipHandled) setTimeout(updateLabel, 0);

  // Expose a tiny debug helper (optional)
  window.gbmMarketChip = {
    _update: updateLabel,
    get zip() { return getZip(); },
    set zip(v) { setZip(v); updateLabel(); },
    onLocal: onLocal,
    onShip: onShip
  };
})();
